// T22.406: the Search pill's hide-on-overlap check (useSearchPillObscured in
// ./index.jsx) only re-measures on scroll, window resize and BODY resize. A
// position:fixed [data-avoid-search-pill] element that MOVES without
// resizing anything (the Edit Wheel bottom bar re-centring under a narrower
// canvas after Add segment opens Segment Settings) fires none of those, so
// the pill stayed drawn over the bar's Rotate control. Such an element calls
// requestSearchPillRecheck() after it moves.
export const SEARCH_PILL_RECHECK_EVENT = "iyuga:search-pill-recheck";

export function requestSearchPillRecheck() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(SEARCH_PILL_RECHECK_EVENT));
}
